import Careers from "../../Careers";

export default function CareersPage() {
  return (
    <>
      <Careers />
    </>
  );
}